import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";

// Returns true when a feature flag is enabled, false otherwise.
export const useFeatureFlag = (key: string): boolean => {
  return useFeatureIsOn(key as never);
};

// Returns the value of a feature flag, falling back to `fallback` when the
// feature is off or has no configured value.
export const useFeatureFlagValue = <T>(key: string, fallback: T): T => {
  return useFeatureValue(key as never, fallback as never) as T;
};
